import { Page } from "../../../../components";
import { useSelector } from "react-redux";
import { NoticeOptions } from "./NoticeOptions";
import { OrderNotifyOptions } from "./OrderNotifyOpitons";
import { UserAppUiOptions } from "./UserAppUiOpitons";
import { FcBrandOption } from "./FcBrandOpiton";
import { ReviewSiteRegister } from "./ReviewSiteRegister";

export default function OthersSetting(props) {
  const { shopInfo } = useSelector(state => state.shop);

  return (
    <Page>
      <OrderNotifyOptions {...props} shopInfo={shopInfo} />

      <br />
      <NoticeOptions {...props} shopInfo={shopInfo} />

      <br />
      <UserAppUiOptions  {...props} shopInfo={shopInfo} />

      <br />
      <ReviewSiteRegister {...props} shopInfo={shopInfo} />
      {/* <FcBrandOption {...props} shopInfo={shopInfo} /> */}
    </Page>
  );
}